import { IonSkeletonText, IonText } from "@ionic/react";
import { useTranslation } from "react-i18next";
import { useQuery } from "@tanstack/react-query";
import { queryOptions_yourMission } from "@/lib/query/functions/personal-mission/your-mission";
import { useMyData } from "@/lib/query/functions/user/data";
import { Routes } from "@/lib/router";
import { cx } from "@/lib/style/cva.config";
import { Button } from "../Global/Button";

export function YourMissionWidget(props: React.ComponentPropsWithoutRef<"div">) {
	const { t } = useTranslation();
	const [myData] = useMyData();

	const queryYourMission = useQuery(queryOptions_yourMission());

	if (!myData.perfectDay.hasCompleted || queryYourMission.data?.personalMission) {
		return <></>;
	}

	if (queryYourMission.isLoading) {
		return <IonSkeletonText animated className="h-42 rounded-3xl" />;
	}

	return (
		<div
			{...props}
			className={cx("bg-brown-100 flex flex-col gap-2 rounded-3xl p-4", props.className)}
		>
			<IonText className="text-brown-700 text-2xl font-bold">
				{t("widgets.your-mission.title")}
			</IonText>

			<IonText className="text-brown-600">{t("widgets.your-mission.description")}</IonText>

			<Button variant="primary" size="small" icon="arrow-right" routerLink={Routes.YourMission()}>
				{t("widgets.your-mission.action")}
			</Button>
		</div>
	);
}
